import { z } from 'zod';
import { EpochMsSchema, UlidSchema } from './common';

export const REPORT_TARGET_KINDS = [
  'profile',
  'post',
  'comment',
  'message',
  'job',
  'org',
] as const;
export const ReportTargetKindSchema = z.enum(REPORT_TARGET_KINDS);

export const REPORT_STATUSES = ['open', 'dismissed', 'actioned'] as const;
export const ReportStatusSchema = z.enum(REPORT_STATUSES);

export const ReportCreateSchema = z.object({
  targetKind: ReportTargetKindSchema,
  targetId: z.string().min(1).max(128),
  reason: z.string().min(1).max(80),
  detail: z.string().max(2000).default(''),
});

export const ReportSchema = z.object({
  id: UlidSchema,
  reporterUserId: UlidSchema,
  targetKind: ReportTargetKindSchema,
  targetId: z.string(),
  reason: z.string(),
  detail: z.string(),
  status: ReportStatusSchema,
  createdAt: EpochMsSchema,
  resolvedAt: EpochMsSchema.nullable(),
  resolvedBy: UlidSchema.nullable(),
  resolution: z.string().nullable(),
});
export const ReportListSchema = z.object({ items: z.array(ReportSchema), nextCursor: z.string().nullable() });
export const ReportIdParamsSchema = z.object({ id: UlidSchema });

export const AdminQueueQuerySchema = z.object({
  status: ReportStatusSchema.default('open'),
  cursor: z.string().min(1).max(512).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export const ADMIN_ACTIONS = ['dismiss', 'remove_content', 'suspend_user', 'unsuspend_user'] as const;
export const AdminActionKindSchema = z.enum(ADMIN_ACTIONS);

export const AdminActionInputSchema = z.object({
  action: AdminActionKindSchema,
  reason: z.string().min(1).max(2000),
  /** Required for suspend_user/unsuspend_user when the report target isn't the user directly. */
  userId: UlidSchema.optional(),
});

export const AdminActionResultSchema = z.object({
  report: ReportSchema,
  action: AdminActionKindSchema,
  auditId: UlidSchema,
});

export const AdminStatsSchema = z.object({
  reports: z.object({
    open: z.number().int().nonnegative(),
    dismissed: z.number().int().nonnegative(),
    actioned: z.number().int().nonnegative(),
  }),
  users: z.object({
    total: z.number().int().nonnegative(),
    suspended: z.number().int().nonnegative(),
  }),
  generatedAt: EpochMsSchema,
});
